<script>
import GameCardWithLink from './GameCardWithLink';

export default {
  name: 'GamesGrid',
  components: {
    GameCardWithLink,
  },
  props: {
    games: {
      required: true,
    },
    col: {
      default: 4,
    },
    rows: {
      default: 4,
    },
  },
  methods: {
    getTransformAnchor (index) {
      const isFirstInCol = index % this.col === 0;
      const isLastInCol = index % this.col === (this.col - 1);
      const currentRow = Math.trunc(index / this.col);
      const isFirstInRow = currentRow === 0;
      const isLastInRow = currentRow === Math.trunc(this.games.length / this.col);
      let xAnchor = 50;
      let yAnchor = 50;
      if (isFirstInCol) xAnchor = 0;
      if (isLastInCol) xAnchor = 100;
      if (isFirstInRow) yAnchor = 0;
      if (isLastInRow && !(this.games.length <= this.col)) yAnchor = 100;
      return `${xAnchor}% ${yAnchor}%`;
    },
  },
};
</script>

<template lang="pug">
grid-container.games-grid(:col="col", :rows="rows")
  game-card-with-link.gamecard(v-for="(game, i) in games", :key="game.id", :game="game", :style="{ transformOrigin: getTransformAnchor(i)}")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.games-grid {
  & .gamecard {
    &:hover {
      transition: transform 0.3s ease-in-out;
      transform: scale(1.1, 1.1);
      position: relative;
      z-index: 10;
    }
  }
}
</style>
